export const DUPLICATE_MEMBER_ERROR_CODE = "DUPLICATE_MEMBER_NAMES";

export interface IDuplicateMemberLocation {
  levelName: string;
  subLevelName: string;
  shopDrawingName: string;
  members: string[];
}

export interface IDuplicateMemberError {
  code: typeof DUPLICATE_MEMBER_ERROR_CODE;
  message: string;
  conflicts: IDuplicateMemberLocation[];
}

export const isDuplicateMemberError = (
  error: any
): error is IDuplicateMemberError =>
  error?.code === DUPLICATE_MEMBER_ERROR_CODE &&
  Array.isArray(error?.conflicts);
